module.exports = __webpack_public_path__ + "img/asia.dbb29f89.svg";